module.exports = __webpack_public_path__ + "static/media/cha-bboki-name2.16338e15.svg";